import { useRef, useState, DragEvent } from 'react'

export const useImportDialogLogic = (
  onFileSelect: (file: File | null) => void
) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [isDragging, setIsDragging] = useState(false)

  const handleDragEnter = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(true)
  }

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    if (!isDragging) setIsDragging(true)
  }

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
  }

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0]
      if (/\.(xlsx|xls|csv)$/i.test(file.name)) {
        onFileSelect(file)
      } else {
        onFileSelect(null)
      }
    }
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0]
      if (/\.(xlsx|xls|csv)$/i.test(file.name)) {
        onFileSelect(file)
      } else {
        onFileSelect(null)
      }
    }
  }

  const handleClearFile = () => {
    if (fileInputRef.current) fileInputRef.current.value = ''
    onFileSelect(null)
  }

  return {
    fileInputRef,
    isDragging,
    handleDragEnter,
    handleDragOver,
    handleDragLeave,
    handleDrop,
    handleFileChange,
    handleClearFile,
  }
}
